;(function ($, window, document) {
    window.ProductList = Me.view.extend({
        options: {},

        initialize: function () {
            _.bindAll(this, 'updateTotalPrice', 'elementRemoverHandler', 'number_format', 'checkForMaximumQuantity', 'stringToNumber');

            this.addEvents();
        },
        addEvents: function () {
            Me.dispatch.subscribe('cart.updateTotalPrice', this.updateTotalPrice);
            Me.dispatch.subscribe('cart.elementHasBeenRemove', this.elementRemoverHandler);
            this.$('.payment a').on('click', this.checkForMaximumQuantity);

        },
        checkForMaximumQuantity: function(e){


            var totalQuantity = 0;
            this.$el.find('.cart-product').each(function (index, value) {
                totalQuantity += parseInt($(value).find('.quantity').text().replace('x',''));
            });

            // @NOTE 2020/05/14 Initially totalQuatity needed to be lower than 20
            if(totalQuantity > 75){
                console.log('bigger than 75');
                e.preventDefault();
                $('html').animate({'scrollTop': 0});
                Me.dispatch.emit('cart.bulkyOrder', this, {isBulky: true});
            }else{
                console.log('lower or equal than 75');
                Me.dispatch.emit('cart.bulkyOrder', this, {isBulky: false});
            }
    
            // Me.dispatch.emit('cart.bulkyOrder', this, {isBulky: false});
    
        },
        updateTotalPrice: function (e, params) {
            var totalPrice = 0;
            var view = this;

            if(params && this.$('.shipping .price').length != 0){
                this.$('.shipping .price').text(params.shippingCost);
                var shippingPrice = this.$('.shipping .price').text();
                shippingPrice = this.stringToNumber(shippingPrice);

                totalPrice += parseFloat(shippingPrice);
            }

            this.$el.find('.cart-product').each(function (index, value) {
                var price = $(value).find('.price').text();
                price = view.stringToNumber(price);

                totalPrice += parseFloat(price);
            });

            totalPrice = this.number_format(totalPrice, 2, ',', ' ');

            this.$('.sous-total .price').text(totalPrice);
        },
        elementRemoverHandler: function () {
            this.updateTotalPrice();

            if((this.$el.find('.cart-product').length) <= 0){
                this.$el.find('.cart-content').addClass('hide');
                this.$el.find('.no-items').removeClass('hide');
                Me.dispatch.emit('cart.noItemsInCart');
            }

        },
        number_format: function (number, decimals, dec_point, thousands_point) {

            if (number === null || !isFinite(number)) {
                throw new TypeError("number is not valid");
            }

            if (!decimals) {
                var len = number.toString().split('.').length;
                decimals = len > 1 ? len : 0;
            }

            if (!dec_point) {
                dec_point = '.';
            }

            if (!thousands_point) {
                thousands_point = ',';
            }

            number = parseFloat(number).toFixed(decimals);

            number = number.replace(".", dec_point);

            var splitNum = number.split(dec_point);
            splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
            number = splitNum.join(dec_point);

            return number;
        },
        stringToNumber: function (number) {
            var temp;
            temp = number.split(' ').join('');
            temp = temp.split(',').join('.');

            return temp;
        }
    });
}(jQuery, window, document));
